import axios from 'axios'
import { baseApiUrl } from '../config/config'

export const getRoutePrice = async (params) => {
  // console.log(params)
  try {
    const res = await axios.post(`${baseApiUrl}/qr/search`, params)
    // console.log(res.data)
    return res.data
  } catch (err) {
    throw new Error(err.name)
    // return null
  }
}

export const getQrCart = async (params) => {
  // console.log(params)
  try {
    const res = await axios.post(`${baseApiUrl}/qr/cart`, params)
    // console.log(res.data)
    return res.data
  } catch (err) {
    throw new Error(err.name)
    // return null
  }
}

export const getOrders = async (params) => {
  // console.log(params)
  try {
    const res = await axios.post(`${baseApiUrl}/orders`, params)
    // console.log(res.data)
    return res.data
  } catch (err) {
    throw new Error(err.name)
    // return null
  }
}
